import LoginRoute from '@/common/login/routes'
import DashboardRoute from '@/modules/dashboard/routes'
import SelecionarModuloPage from '@/modules/app/ctrl-modulos/pages/SelecionarModuloPage'

import routesApp  from '@/modules/app/routes'
import routesWorkflow  from '@/modules/workflow/routes'

const routes = [{
        name: '',
        path: '/',
        redirect: 'login',
        component: () => import ('@/common/login/components/LoginPage.vue'),
        children: [
            ...LoginRoute,
        ]
    },
    {
        name: '',
        path: '/',
        component: () => import ('@/layouts/MainLayout'),
        children: [
            ...DashboardRoute,
        ]
    },
    {
        name: '',
        path: '/app',
        component: () => import ('@/layouts/MainLayout'),
        meta: { requiresModule: true },
        children: routesApp,
    },
    {
        name: '',
        path: '/workflow',
        component: () => import ('@/layouts/MainLayout'),
        meta: { requiresModule: true },
        children: routesWorkflow,
    },
    {
        path: '/selecionar-modulo',
        name: 'SelecionarModulo',
        component: SelecionarModuloPage
    },
    {
        path: '*',
        name: 'pagina-nao-encontrada',
        component: () => import ('@/layouts/Page404.vue'),
    },
]

export default routes
